export const coverAndWrapSelectOptions = {
  size: "cover",
  cssClass: "select-option-wrap"
};

export const defaultSelectOptions = coverAndWrapSelectOptions;

